export const getCoinsActionText = (coins) => {
  if (coins === 1) {
    return 'монету'
  } else if (coins >= 2 && coins <= 4) {
    return 'монеты'
  } else {
    return 'монет'
  }
}